// extracted by mini-css-extract-plugin
export default {"navbarHeight":"72px"};